import { useEffect } from "react";
import ZoomInterface from "./ZoomInterface";

function ZoomWrapper(props) {
  return (
    <>
      <ZoomInterface
        subfolder={props.subfolder}
        meetingData={props.meetingData}
        signature={props.signature}
        hostEmail={props.hostEmail}
        clientName={props.clientName}
        user={props.user}
      ></ZoomInterface>
    </>
  );
}

export default ZoomWrapper;
